/**
 * 碎片
 * 碎片API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../course_standard/model/CreatedVo';
import FragmentCreateForm from '../../course_standard/model/FragmentCreateForm';
import FragmentDetailVo from '../../course_standard/model/FragmentDetailVo';
import FragmentEditForm from '../../course_standard/model/FragmentEditForm';
import FragmentResCreateForm from '../../course_standard/model/FragmentResCreateForm';
import OssStsAkVo from '../../course_standard/model/OssStsAkVo';
import PagingFragmentVo from '../../course_standard/model/PagingFragmentVo';
import UpdatedVo from '../../course_standard/model/UpdatedVo';
  /**
   * Fragment service.
   * @module course_standard/api/FragmentApi
   * @version 0.2.0
   */

  /**
   * Constructs a new FragmentApi. 
   * @alias module:course_standard/api/FragmentApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 新增碎片
     * @param {module:course_standard/model/FragmentCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.addFragment = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addFragment";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/fragment/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增碎片附件
     * @param {Integer} id 碎片id
     * @param {module:course_standard/model/FragmentResCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.addFragmentRes = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling addFragmentRes";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addFragmentRes";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}/res', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增section碎片关联
     * @param {Integer} sectionId 云教材小节id
     * @param {Integer} fragmentId 碎片id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.addSectionLink = function(sectionId, fragmentId) {
      var postBody = null;

      // verify the required parameter 'sectionId' is set
      if (sectionId == undefined || sectionId == null) {
        throw "Missing the required parameter 'sectionId' when calling addSectionLink";
      }

      // verify the required parameter 'fragmentId' is set
      if (fragmentId == undefined || fragmentId == null) {
        throw "Missing the required parameter 'fragmentId' when calling addSectionLink";
      }


      var pathParams = {
        'sectionId': sectionId
      };
      var queryParams = {
        'fragmentId': fragmentId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/fragment/section_link/{sectionId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除碎片
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deleteFragment = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteFragment";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除碎片
     * @param {Integer} id id
     * @param {Integer} resId resId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deleteFragmentRes = function(id, resId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteFragmentRes";
      }

      // verify the required parameter 'resId' is set
      if (resId == undefined || resId == null) {
        throw "Missing the required parameter 'resId' when calling deleteFragmentRes";
      }


      var pathParams = {
        'id': id,
        'resId': resId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}/res/{resId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查找section下关联碎片
     * @param {Integer} sectionId 云教材小节id
     * @param {Integer} pageNum 页码
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/PagingFragmentVo}
     */
this.findPagingSectionLinked = function(sectionId, pageNum) {
      var postBody = null;

      // verify the required parameter 'sectionId' is set
      if (sectionId == undefined || sectionId == null) {
        throw "Missing the required parameter 'sectionId' when calling findPagingSectionLinked";
      }

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingSectionLinked";
      }


      var pathParams = {
        'sectionId': sectionId
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingFragmentVo;
      return this.apiClient.callApi(
        '/api/fragment/section_link/{sectionId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 碎片详情
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/FragmentDetailVo}
     */
this.getFragment = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getFragment";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = FragmentDetailVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取oss访问令牌
     * @param {Integer} id 碎片id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/OssStsAkVo}
     */
this.getStsAk = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getStsAk";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OssStsAkVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}/res/get_sts_ak', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 移除section碎片关联
     * @param {Integer} sectionId 云教材小节id
     * @param {Integer} fragmentId 碎片id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.removeSectionLink = function(sectionId, fragmentId) {
      var postBody = null;

      // verify the required parameter 'sectionId' is set
      if (sectionId == undefined || sectionId == null) {
        throw "Missing the required parameter 'sectionId' when calling removeSectionLink";
      }

      // verify the required parameter 'fragmentId' is set
      if (fragmentId == undefined || fragmentId == null) {
        throw "Missing the required parameter 'fragmentId' when calling removeSectionLink";
      }


      var pathParams = {
        'sectionId': sectionId
      };
      var queryParams = {
        'fragmentId': fragmentId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/fragment/section_link/{sectionId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 搜索碎片
     * @param {Integer} pageNum 页码
     * @param {Integer} courseStandardId 课程标准id，必填
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.knowledgeId 课程目标知识点id
     * @param {Integer} opts.companyId 上传院校id
     * @param {Integer} opts.accountId 上传者id
     * @param {String} opts.text 检索词 选填
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/PagingFragmentVo}
     */
this.searchFragment = function(pageNum, courseStandardId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling searchFragment";
      }

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling searchFragment";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'courseStandardId': courseStandardId,
        'knowledgeId': opts['knowledgeId'],
        'companyId': opts['companyId'],
        'accountId': opts['accountId'],
        'text': opts['text']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingFragmentVo;
      return this.apiClient.callApi(
        '/api/fragment/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改碎片
     * @param {Integer} id id
     * @param {module:course_standard/model/FragmentEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.updateFragment = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateFragment";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateFragment";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/fragment/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
